import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClientProvider } from '@tanstack/react-query'
import AppUpdateBanner from '@/components/AppUpdateBanner'
import { AppErrorBoundary } from '@/components/AppErrorBoundary'
import { getGoogleClientId } from '@/config/env'
import { queryClient } from '@/query/queryClient'
import AppThemeProvider from '@/theme/AppThemeProvider'

/**
 * Root provider stack for the SPA (query, theme, error boundary).
 * Router lives outside in main.jsx via RouterProvider.
 *
 * The session is restored synchronously in main.jsx (rehydrateAuthSession),
 * so there is no async auth bootstrap to gate rendering on here.
 *
 * @param {{ children: import('react').ReactNode }} props
 */
export default function AppProviders({ children }) {
  const googleClientId = getGoogleClientId()

  const tree = (
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <AppErrorBoundary>
          {children}
          <AppUpdateBanner />
        </AppErrorBoundary>
      </AppThemeProvider>
    </QueryClientProvider>
  )

  if (googleClientId) {
    return <GoogleOAuthProvider clientId={googleClientId}>{tree}</GoogleOAuthProvider>
  }

  return tree
}
